var exports = {
  "DD": "xdbfd91f1--3e16f5--title",
  "h_": "xdbfd91f1--3e16f5--description",
  "q9": "xdbfd91f1--3e16f5--price",
  "cL": "xdbfd91f1--3e16f5--builder",
  "W0": "xdbfd91f1--3e16f5--builder_icon",
};

module.exports = exports;
